import { Button } from '@/components/ui/button';

export const Header = () => {

  return (
    <header className="fixed top-0 left-0 right-0 bg-white border-b border-gray-200 z-50">
      <div className="max-w-[1200px] mx-auto px-4 h-[72px] flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center">
          <a href="/" className="flex items-center">
            <img 
              src="/lovable-uploads/levot_logo.png"
              alt="Logo" 
              className="h-14 w-auto md:h-22"
            />
          </a>
        </div>

        {/* Contact button */}
        <div className="flex items-center space-x-4">
          <Button
            onClick={() => window.open('https://cal.com/levot-labs-cptefe/30min?overlayCalendar=true', '_blank')}
            className="bg-[#18181B] hover:bg-[#18181B]/90 text-white rounded-lg px-4 py-2 text-[15px] font-medium"
          >
            Book a Demo
          </Button>
        </div>
      </div>
    </header>
  );
};
